import React from 'react'
import Tooltip from './Tooltip'
import { FIELD_TOOLTIPS } from '../utils/fieldTooltips'

export default function EdicionToolbar({
  reviewTab, rows, modoHerramienta, asistidoMode,
  showManualRangePanel, setShowManualRangePanel,
  manualRangeDraft, setManualRangeDraft, applyManualRange,
}) {
  return (
    <div className="mt-2 space-y-2">
      <div className="rounded-lg border border-rose-300/45 bg-rose-500/15 p-2 text-xs text-rose-100">
        {asistidoMode ? (
          <Tooltip text={FIELD_TOOLTIPS.advertenciaPericial.tooltipText}>Advertencia pericial estricta</Tooltip>
        ) : 'Advertencia pericial estricta'}: los períodos de moratoria no integran el promedio de PC/PAP (solo derecho de acceso).
        En filas de autónomos, revisar doctrina Mackler/Volonté antes de cerrar liquidación.
      </div>
      {rows.some((r) => Boolean(r?.dobleEmpleo)) && (
        <div className="rounded-lg border border-amber-300/45 bg-amber-500/15 p-2 text-xs text-amber-100">
          {asistidoMode ? (
            <Tooltip text={FIELD_TOOLTIPS.simultaneidadDetectada.tooltipText}>Simultaneidad detectada</Tooltip>
          ) : 'Simultaneidad detectada'} (mismo mes con más de un CUIT). Revisá columna Días y montos por fila.
          El sistema asiste la consolidación, pero la validación pericial final debe confirmar que no haya sobrecómputo.
        </div>
      )}
      {modoHerramienta === 'avanzado' && (
        <div className="flex items-center justify-end">
          <button
            type="button"
            onClick={() => setShowManualRangePanel((p) => !p)}
            className="rounded-lg border border-white/25 bg-white/10 px-3 py-1.5 text-xs font-semibold text-white"
          >
            Agregar periodo manual por rango
          </button>
        </div>
      )}
      {modoHerramienta === 'avanzado' && showManualRangePanel && (
        <div className="rounded-lg border border-amber-300/40 bg-amber-500/10 p-3">
          <p className="mb-2 text-xs font-semibold text-amber-100">Carga manual por rango (Desde/Hasta)</p>
          <div className="grid grid-cols-1 gap-2 md:grid-cols-4">
            <input type="text" value={manualRangeDraft.desde} onChange={(e) => setManualRangeDraft((p) => ({ ...p, desde: e.target.value }))} className="h-9 rounded border border-white/25 bg-slate-900/60 px-2 text-white" placeholder="Desde (DD/MM/AAAA)" />
            <input type="text" value={manualRangeDraft.hasta} onChange={(e) => setManualRangeDraft((p) => ({ ...p, hasta: e.target.value }))} className="h-9 rounded border border-white/25 bg-slate-900/60 px-2 text-white" placeholder="Hasta (DD/MM/AAAA)" />
            <input type="text" value={manualRangeDraft.empleador} onChange={(e) => setManualRangeDraft((p) => ({ ...p, empleador: e.target.value }))} className="h-9 rounded border border-white/25 bg-slate-900/60 px-2 text-white" placeholder="Empleador" />
            <input type="text" value={manualRangeDraft.cuit} onChange={(e) => setManualRangeDraft((p) => ({ ...p, cuit: e.target.value.replace(/\D/g, '') }))} className="h-9 rounded border border-white/25 bg-slate-900/60 px-2 text-white" placeholder="CUIT" />
          </div>
          <div className="mt-2 flex flex-wrap items-center gap-3">
            <button type="button" onClick={applyManualRange} className="rounded border border-amber-300/40 bg-amber-500/20 px-3 py-1 text-xs font-semibold text-amber-100">Aplicar rango</button>
            <label className="inline-flex items-center gap-2 text-xs text-amber-100">
              <input
                type="checkbox"
                checked={Boolean(manualRangeDraft.forzarAgregar)}
                onChange={(e) => setManualRangeDraft((p) => ({ ...p, forzarAgregar: e.target.checked }))}
              />
              Forzar agregar periodo (no reemplazar filas existentes del mismo mes)
            </label>
          </div>
        </div>
      )}
    </div>
  )
}
